import AComponent from './layer-category-list.vue'
export default AComponent
